// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__32mz5","insightsList":"newBusinessInsightsMenu_insightsList__1twxX","active":"newBusinessInsightsMenu_active__a419z"};